// Lifecycle states a payin or payout can be in, as the API serialises them
// (InstanceState's @JsonValue — lower snake case).

/**
 * States in which a decision has already been made.
 *
 * Mirrors ManualDecision.TERMINAL in core-processor, and must stay in step with
 * it: the API refuses a manual confirm or reject on any of these (bar confirming
 * an expired payin — see canDecidePayin), so offering the action for one would
 * only produce an error. The backend is the authority — this
 * copy exists to keep a doomed menu item off the screen, not to decide anything.
 *
 * Re-deciding a finished transaction is the case worth refusing: confirming an
 * already-refused payout would credit a wallet for money that never moved.
 */
export const TERMINAL_STATES = [
    'processed',
    'withdrawed',
    'withdraw_cancelled',
    'refused',
    'cancelled',
    'expired'
];

export const isTerminalState = (state) =>
    TERMINAL_STATES.includes(String(state || '').toLowerCase());

/**
 * Whether an operator may confirm or reject (`action`) a payin in `state`.
 *
 * Mirrors ManualDecision.mayDecidePayin: nothing terminal may be decided, except
 * that an expired payin may still be confirmed — its money can arrive after the
 * gateway's window closed. Rejecting one is refused: it already counts as unpaid.
 */
export const canDecidePayin = (state, action) => {
    const s = String(state || '').toLowerCase();
    return !TERMINAL_STATES.includes(s) || (s === 'expired' && action === 'confirm');
};
